export default "__VITE_ASSET__CZMAO_4W__"